import type {GotchaQueryVariables} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Gotcha 도메인 Query Key 관리
 */
export const GOTCHA_QUERY_KEY_MAP = {
  /**
   * 갓챠 정보 조회
   * Origin: useGotchaQuery.getKey
   */
  gotcha: (variables: GotchaQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'gotcha', variables] as const,
} as const;

/**
 * Gotcha 도메인 Mutation Key 관리
 */
export const GOTCHA_MUTATION_KEY_MAP = {
  /**
   * 가챠 뽑기
   * Origin: useDrawGotchaMutation (getKey 없음)
   */
  drawGotcha: 'drawGotcha',
} as const;
